import _ from 'lodash'

export const getProposals = (state, props) => _.get(state, 'leadProposalActions.leadProposals.data')

export const getProposalTemplates = (state, props) =>
  _.get(state, 'proposalTemplate.proposalTemplates.data')

export const getProposalTemplateSections = (state, props) =>
  _.get(state, 'proposalTemplate.proposalTemplateSections.data')

export const getProposalTemplateItems = (state, props) =>
  _.get(state, 'proposalTemplate.proposalTemplateItems.data')

export const getProposalSections = (state, props) =>
  _.get(state, 'leadProposalActions.leadProposalSections.data')

export const getProposalItems = (state, props) =>
  _.get(state, 'leadProposalActions.leadProposalItems.data')

export const getProposalMilestonesTemplate = (state, props) =>
  _.get(state, 'proposalActions.proposalMilestonesTemplate.data')

export const getProposalMilestones = (state, props) =>
  _.get(state, 'proposalActions.proposalMilestones.data')

export const getTemporarilySavedProposals = (state, props) =>
  _.get(state, 'leadProposalActions.temporarilySavedLeadProposals.data')

export const getProposalIdParam = (state, props) => _.get(props, 'match.params.proposalId')



// WEBPACK FOOTER //
// ./src/selectors/lead/proposals.js